import { registerMutation, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const API_BASE = '/knowledge-content/v2/import';
export const START_SMART_COPY = registerMutation({
  fieldName: 'startSmartCopy',
  args: ['autoPublish', 'knowledgeBaseId', 'url'],
  fetcher(data) {
    return http.post(`${API_BASE}/start`, {
      data: Object.assign({}, data, {
        bulkImport: true
      })
    });
  }
});
export const CANCEL_SMART_COPY = registerMutation({
  fieldName: 'cancelSmartCopy',
  args: ['knowledgeBaseId'],
  fetcher: query => http.put(`${API_BASE}/cancel`, {
    query
  })
});
export const GET_SMART_COPY_PROGRESS = registerQuery({
  fieldName: 'smartCopyProgress',
  args: ['knowledgeBaseId'],
  fetcher(query) {
    return http.get(`${API_BASE}/progress`, {
      query
    });
  }
});
export const GET_SMART_COPY_WARNINGS_COUNT = registerQuery({
  fieldName: 'smartCopyWarningsCount',
  args: ['knowledgeBaseId'],
  fetcher(query) {
    return http.get(`${API_BASE}/warning/count`, {
      query
    });
  }
});
export const GET_SMART_COPY_WARNINGS_FILE = registerQuery({
  fieldName: 'smartCopyWarningsFile',
  args: ['knowledgeBaseId'],
  fetcher(query) {
    return http.get(`${API_BASE}/warning/file`, {
      query
    });
  }
});